import { RadioList as RL } from './RadioList';
import { RADIO_LIST_VARIANTS, Props } from './types';

export type RadioListVariantProps = Omit<Props, 'variant'>;

const RadioList = (props: RadioListVariantProps) => (
  <RL {...props} variant={RADIO_LIST_VARIANTS.DEFAULT} />
);

const BorderedRadioList = (props: RadioListVariantProps) => (
  <RL {...props} variant={RADIO_LIST_VARIANTS.BORDERED} />
);

export { RadioList, BorderedRadioList };
